import http from 'infra/http';
import { useQuery } from 'react-query';
import { ParametroCobrancaResponse } from '../typings';

function useParametrosCobranca(tenant?: string) {
  const url = `v1/parametros-cobranca/${tenant}`;
  return useQuery(url, async () => {
    const { data } = await http.get<ParametroCobrancaResponse>(url);
    return data;
  }, {
    enabled: !!tenant,
  });
}

export default useParametrosCobranca
